var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcrFilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#EFF2F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13519_148493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13519_148493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6006 10.4092H21.6504C21.8863 10.4092 22.1115 10.4503 22.3252 10.5332C22.5388 10.6161 22.7373 10.749 22.9199 10.9316L26.6699 14.6816C26.8524 14.8642 26.9855 15.0619 27.0684 15.2754C27.1513 15.4892 27.1924 15.7142 27.1924 15.9502V27.8008C27.1923 28.2933 27.0169 28.7146 26.666 29.0654C26.3149 29.4164 25.8925 29.5918 25.3994 29.5918H14.5938C14.1007 29.5918 13.6805 29.4164 13.332 29.0654C12.9837 28.7146 12.8097 28.2934 12.8096 27.8008V12.2002C12.8096 11.7075 12.9841 11.2855 13.335 10.9346C13.6859 10.5837 14.1079 10.4092 14.6006 10.4092ZM14.6006 12.2002H14.5928V27.8008H14.6006V27.8086H25.4004V27.8008H25.4092V16.4004H25.4004V16.3916H22.1006C21.8479 16.3916 21.6366 16.3064 21.4658 16.1357C21.295 15.9649 21.209 15.7529 21.209 15.5V12.2002H21.2012V12.1924H14.6006V12.2002ZM17.3076 24.209H22.7021C22.9545 24.2091 23.1654 24.2956 23.3359 24.4688C23.5066 24.6421 23.5927 24.8541 23.5928 25.1055C23.5928 25.3568 23.5054 25.5674 23.332 25.7373C23.1587 25.907 22.9459 25.9922 22.6934 25.9922H17.2998C17.0473 25.9922 16.8357 25.9057 16.665 25.7324C16.4943 25.559 16.4092 25.3461 16.4092 25.0947C16.4093 24.8437 16.4959 24.6336 16.6689 24.4639C16.8423 24.294 17.0551 24.209 17.3076 24.209ZM17.3076 20.6084H22.7021C22.9546 20.6085 23.1653 20.6959 23.3359 20.8691C23.5066 21.0425 23.5928 21.2545 23.5928 21.5059C23.5927 21.7571 23.5053 21.9679 23.332 22.1377C23.1587 22.3073 22.9458 22.3916 22.6934 22.3916H17.2998C17.0472 22.3916 16.8357 22.3052 16.665 22.1318C16.4944 21.9585 16.4092 21.7464 16.4092 21.4951C16.4092 21.2438 16.4956 21.0332 16.6689 20.8633C16.8423 20.6935 17.0551 20.6085 17.3076 20.6084Z",
    fill: "#272C34",
    stroke: "#272C34",
    strokeWidth: 0.0166667
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrFilePlaceholder);
export default __webpack_public_path__ + "static/media/ocr-file-placeholder.687cfd67e726078756bd6930d56da1f5.svg";
export { ForwardRef as ReactComponent };